"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
/**
 * Блок с полями по бокам для размещения контента по вертикали.
 * Блок нельзя вкладывать сам в себя или дальше по дереву.
 */
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 auto;\n\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: column;\n\n    width: 100%;\n    padding-left: var(--plasma-grid-margin);\n    padding-right: var(--plasma-grid-margin);\n"], ["\n    margin: 0 auto;\n\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: column;\n\n    width: 100%;\n    padding-left: var(--plasma-grid-margin);\n    padding-right: var(--plasma-grid-margin);\n"])));
var templateObject_1;
//# sourceMappingURL=Container.js.map